import { RequestType } from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';

export interface SendMessageToUserRequest {
  userId: string;
  message: {
    title: string;
    body: string;
    data?: { [key: string]: string };
    imageUrl?: string;
  };
}

export interface SendMessageToUserResponse {
  success: boolean;
  messageId?: string;
  error?: string;
}

@RequestType({
  responseType: Object,
  genericTypes: { TRequestBody: Object },
  scope: 'public'
})
export class SendMessageToUserServiceRequest extends ServiceRequestBase<SendMessageToUserRequest, SendMessageToUserResponse> {
  static serviceName: string = 'NaniumDemo:firebase/sendMessageToUser';
}
